import { HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr"
import Settings from "@/common/Settings"

const getAuthToken = (): string => {
  return localStorage.getItem("LogedUser") || localStorage.getItem("token") || ""
}

export const createRealtimeConnection = (): HubConnection => {
  return new HubConnectionBuilder()
    .withUrl(Settings.SignalURL, {
      accessTokenFactory: () => getAuthToken(),
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(LogLevel.Warning)
    .build()
}

export const startConnectionSafe = async (connection: HubConnection): Promise<boolean> => {
  try {
    await connection.start()
    return true
  } catch (error) {
    console.error("SignalR connection failed:", error)
    return false
  }
}

export const stopConnectionSafe = async (connection?: HubConnection | null): Promise<void> => {
  if (!connection) return
  try {
    await connection.stop()
  } catch (error) {
    console.error("SignalR disconnect failed:", error)
  }
}
